import { useState, useEffect, useCallback } from 'react';
import { api } from '../api/gridApi';

export function useGridData(refreshInterval = 5000) {
  const [gridData, setGridData] = useState(null);
  const [source, setSource] = useState('simulated');
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const result = await api.getLiveGrid();
    setGridData(result.data);
    setSource(result.source);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, refreshInterval);
    return () => clearInterval(interval);
  }, [refresh, refreshInterval]);

  return { gridData, source, loading, refresh };
}

export function useForecast(hours = 72) {
  const [forecast, setForecast] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getForecast(hours).then(r => {
      setForecast(r.data);
      setLoading(false);
    });
  }, [hours]);

  return { forecast, loading };
}

export function useFaults() {
  const [faults, setFaults] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const r = await api.getFaults();
    setFaults(r.data);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 15000);
    return () => clearInterval(interval);
  }, [refresh]);

  return { faults, loading, refresh, addFault: (f) => setFaults(prev => [f, ...prev]) };
}

export function useZones() {
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getZones().then(r => {
      setZones(r.data);
      setLoading(false);
    });
    const interval = setInterval(() => {
      api.getZones().then(r => setZones(r.data));
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return { zones, loading };
}
